import { AxiosFactory } from 'emrn-api/AxiosFactory';
import { getRequestId } from 'emrn-api/getRequestId';
import { getDsbcApiRequest } from './_dsapi/DsbcApiBaseRequest';
import { DsbcApiOptions } from './_dsapi/DsbcApiOptions';

class DsbcApiAxiosRequest extends AxiosFactory {
  constructor() {
    super('DsbcApiAxiosRequest');
    this.fetch = this.fetch.bind(this);
  }

  /**
   * 获取接口数据
   * @param url 请求地址
   * @param data 请求数据
   * @param options 请求配置
   * @returns
   */
  async fetch<ResponseT>(url: string, data: object, needLogin: boolean, options: DsbcApiOptions = {}) {
    const requestId = getRequestId(new Date(), 32);
    data = await getDsbcApiRequest(data, needLogin);
    url = `${url}${url.includes('?') ? '&' : '?'}rd=${requestId}`;
    const axios2Res = await this.axios2<ResponseT>(
      {
        url,
        data,
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
      },
      { requestId, ...options }
    );

    return axios2Res.data;
  }
}

/**
 * 大赛bc接口请求类`单例`对象
 */
export const DsbcApi = new DsbcApiAxiosRequest();
